<template>
  <a class="twitter-timeline" data-height="560" href="https://twitter.com/Rw_csirt?ref_src=twsrc%5Etfw"></a>
</template>
<script>
export default {
  name: "CertTwitterTimeline",
  props: {
    height: {
      type: Number,
      default: 0,
    }
  },
  created() {
    let twitterScript = document.createElement('script');
    twitterScript.setAttribute('id', 'twitterScript');
    twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js');
    document.head.appendChild(twitterScript);
  },
}
</script>
